import React from "react"
import { Badge, Button } from "reactstrap"

const AccountTransactionHeader = ({
  handleRefresh,
  resetParams,
  isRefetching,
  hasActiveFilters,
  total,
  onExportPdf,
  isExporting,
  onExportCsv,
  isExportingCsv,
}) => {
  return (
    <div className="d-flex align-items-center">
      <h5 className="mb-0 mt-3 card-title flex-grow-1">
        Total <Badge className="badge-soft-info">{total ?? 0}</Badge>
      </h5>
      <div className="flex-shrink-0">
        <Button color="success" outline onClick={onExportPdf} disabled={isExporting}>
          <i className={`mdi mdi-file-pdf-box me-1 ${isExporting ? "mdi-spin" : ""}`} />
          {isExporting ? "Exporting..." : "Export PDF"}
        </Button>
        <Button color="info" outline onClick={onExportCsv} disabled={isExportingCsv} className="ms-1">
          <i className={`mdi mdi-file-delimited-outline me-1 ${isExportingCsv ? "mdi-spin" : ""}`} />
          {isExportingCsv ? "Exporting..." : "Export CSV"}
        </Button>
        <Button color="light" onClick={handleRefresh} className="ms-1">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
        {hasActiveFilters && (
          <Button color="danger" onClick={resetParams} className="ms-1">Reset Filters</Button>
        )}
      </div>
    </div>
  )
}

export default AccountTransactionHeader
